import React, { useContext, useState, useEffect } from 'react';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button } from '@mui/material';
import DrawerContext from '../../../context/DrawerContext.js';

const DeleteNoteModal = () => {


  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const drawerCtx = useContext(DrawerContext);

  const closeHandle = () => {
    modalCtx.closeModal();
  }

  const handleDelete = () => {
    const { companyId, id } = modalCtx.details;
    
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyId}/notes/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authCtx.token}` },
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "success") {
        drawerCtx.setPageUpdate({ page: "Companies", companyId, id });    
      } else {
        console.error("Failed to delete note:", data.message);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
    
  };

  return (
    <>
      <div className="create-devotional-container">
        <div className='devotional-header'>
          <h1>Delete Note</h1>
          {/* <CloseRounded className='close' onClick={() => closeHandle()} /> */}
        </div>
        <div className=" body-container create-container">
          <span>Are you sure you want to delete this note ?</span>
        </div>
        <div className="footer-devotional">
        <Button style={{color:"#555"}} onClick={() => closeHandle()}>No</Button>
        <Button style={{color:"#555"}} onClick={() => { handleDelete(); closeHandle(); }}>Yes</Button>
        </div>
      </div>
    </>
  )
}

export default DeleteNoteModal;
